import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import enTranslation from "../locales/en/translation.json";
import jaTranslation from "../locales/ja/translation.json";
import filTranslation from "../locales/fil/translation.json";
import viTranslation from "../locales/vi/translation.json";

// Get initial language from localStorage or default to "en"
const getInitialLanguage = (): string => {
  const savedLanguage = localStorage.getItem("language");
  if (savedLanguage && ["en", "ja", "fil", "vi"].includes(savedLanguage)) {
    return savedLanguage;
  }
  return "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    ja: {
      translation: jaTranslation,
    },
    fil: {
      translation: filTranslation,
    },
    vi: {
      translation: viTranslation,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  // Enable debugging to detect missing translations
  debug: import.meta.env.DEV, // Only enable in development mode
  saveMissing: true,
  // Custom handler to log missing translation keys
  missingKeyHandler: (lngs, ns, key, fallbackValue) => {
    if (import.meta.env.DEV) {
      console.warn(
        `[i18next] Missing translation key: "${key}" for language(s): ${lngs.join(", ")}`,
        fallbackValue ? `(fallback: "${fallbackValue}")` : "",
      );
    }
  },
});

export default i18n;
